var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"overlay__title"},[_vm._v("\n    "+_vm._s(_vm.$t('reset_password.reset_password'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"overlay__text"},[_vm._v("\n    "+_vm._s(_vm.$t('reset_password.enter_new_password'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"overlay__form-wrapper"},[_c('ResetPasswordForm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }